//Margin conventions
var margin = {top: 25, right: 5, bottom: 30, left: 33};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 300 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;  

//Formats numbers in thousands
format = d3.format("0,000");

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(8)
  .ticks(5)
  .tickFormat(function(d) { return format(d); })
	.orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
  .tickPadding(8)
	.orient("bottom")
  .ticks(8)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var line = d3.svg.line()
  .x(function(d) { return xScale(d.date); })
  .y(function(d) { return yScale(d.rate); });   

//Loads the data
d3.csv("data/CrimeStatebyState.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.rate = +d.rate;
    d.date = parseDate(d.date);
	});
	
	//Organizes the data	
  data.sort(function(a,b) { return a.date - b.date; });
  var maxY = d3.max(data, function(d) { return d.rate; });
  var maxX = d3.max(data, function(d) { return d.date; });

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.date; }));

  //Defines the yScale max
  yScale.domain([0, 800]);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.call(yAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);   

  //Binds the data to the line
  var drawline = svg.append("path")
    .datum(data)
    .attr("class", "line")
    .attr("d", line); 


  //Adding circle label  
  var labelElements = svg.append("g")
    .attr("class", "fiddly-bits")

  var label = labelElements.selectAll(".g-label-element")
    .data(data.filter(function(d) { return d.date == maxX; }))
    .enter().append("g")
    .attr("class", "g-label-element")
    .attr("transform", function(d) { return "translate(" + xScale(d.date) + "," + yScale(d.rate) + ")"; } );

  label.append("circle")
    .attr("r", 4)
    .attr("class", "g-label-circle");

  label.append("text")
    .attr("x", -30)
    .attr("y",18)
    .text("2015:")
    .attr("class", "g-label-text-bold"); 

  label.append("text")
    .attr("x", -30)
    .attr("y", 35)
    .text("372.6")
    .attr("class", "g-label-text");    

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 25, right: 5, bottom: 30, left: 33};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the line
    line = d3.svg.line()
      .x(function(d) { return xScale(d.date); })
      .y(function(d) { return yScale(d.rate); }); 

    d3.selectAll('.line')
      .attr("d", line); 

    //Updates circle labels 
    label
      .attr("transform", function(d) { return "translate(" + xScale(d.date) + "," + yScale(d.rate) + ")"; } );  

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(8);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);
  };

}